// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    UNSUBSCRIBED_CONTACT_CREATE_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    createUnsubscribedContactResult
} from 'Redux/actions';

// Helpers
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* createUnsubscribedContact({ payload }) {
    try {
        let QUERY = `
            mutation createUnsubscribedContact ($to: String!, $source: String, $reason: String) {
                result: createUnsubscribedContact (to: $to, source: $source, reason: $reason) {
                    id
                    to
                    source
                    reason
                    jsonValue
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data) yield put(createUnsubscribedContactResult(data?.result))
        else yield put(createUnsubscribedContactResult({ error: true }))

    } catch (exc) {
        ExceptionManager(
            exc,
            'Modules/unsubscribedContacts/.components/createUnsubscribedContact/redux/saga',
            'createUnsubscribedContact'
        );
        yield put(createUnsubscribedContactResult({ error: true, errorMessage: exc?.error }))
    }
}

function* watchMethods() {
    yield takeEvery(UNSUBSCRIBED_CONTACT_CREATE_REQUEST, createUnsubscribedContact);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}